import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { constants } from 'src/app/constants';
import { SearchTourComponent } from 'src/app/components/search-tour/search-tour.component';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HC_3d from 'highcharts/highcharts-3d';
import { ScheduleService } from 'src/app/api/departure/schedule.service';
import { ToolsService } from 'src/app/utils/tools.service';
declare var $: any;
HC_exporting(Highcharts);
HC_3d(Highcharts);

@Component({
  selector: 'app-schedule-report',
  templateUrl: './schedule-report.component.html',
  styleUrls: ['./schedule-report.component.css']
})
export class ScheduleReportComponent implements OnInit {
  private thisComponent: ScheduleReportComponent;
  @ViewChild(SearchTourComponent) SearchTourComponent: any;

  updateFlag = false;
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};

  branchofficeSlug: string = '';

  // variables
  date_result: any = moment();
  year: any = moment().format('yyyy');
  generate: boolean = false;
  tourSelected: any = null;
  is_all: boolean = false;
  ViewSummarySelected: any = null;
  viewsummary: any = constants.REPORT.VIEW_SCHEDULE;
  view_yearly: any = constants.REPORT.VIEW_SCHEDULE[0];
  view_monthly: any = constants.REPORT.VIEW_SCHEDULE[1];
  // / results_data
  response_summarytour: any = null;

  obj_months = [
    { id: 1,number_month: 1, name: 'Ene', value: 0 },
    { id: 2, number_month: 2, name: 'Feb', value: 0 },
    { id: 3, number_month: 3, name: 'Mar', value: 0 },
    { id: 4,number_month: 4, name: 'Abr', value: 0 },
    { id: 5,number_month: 5, name: 'May', value: 0 },
    { id: 6,number_month: 6, name: 'Jun', value: 0 },
    { id: 7,number_month: 7, name: 'Jul', value: 0 },
    { id: 8,number_month: 8, name: 'Ago', value: 0 },
    { id: 9,number_month: 9, name: 'Set', value: 0 },
    { id: 10,number_month: 10, name: 'Oct', value: 0 },
    { id: 11,number_month: 11, name: 'Nov', value: 0 },
    { id: 12,number_month: 12, name: 'Dec', value: 0 }
  ];

  params: any = {
    tour_id: null,
    is_all: false,
  };

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private scheduleService: ScheduleService,
    private route: ActivatedRoute,
    public toolsService: ToolsService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.ViewSummarySelected = this.view_yearly.id;
  }

  ngOnInit() {
    // this.navigationTrackerService.initializeMenu(this.route);
    let component_ = this.thisComponent;
    (<any>$('#year')).datepicker({
      autoclose: true,
      changeYear: false,
      format: 'yyyy',
      viewMode: 'years',
      minViewMode: 'years'
    });
  }

  selectedTourSearch(item_: any) {
    this.tourSelected = item_;
    this.params.tour_id = item_.id;
  }

  removeTour() {
    this.tourSelected = null;
    this.params.tour_id = null;
    setTimeout(() => {
      this.SearchTourComponent.focused();
    }, 150);
  }

  changeViewSummary() {
    this.reset();
  }

  initializeChart() {
    this.chartOptions = {
      chart: {
        type: 'line'
      },
      title: {
        text: 'Histórico de Reservas por mes'
      },
      subtitle: {
        text: 'Año: ' + moment(this.date_result).format('YYYY')
      },
      xAxis: {
        categories: [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Oct',
          'Nov',
          'Dic'
        ]
      },
      yAxis: {
        title: {
          text: 'Cantidad'
        }
      },
      series: [
        {
          name: 'Meses',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ]
    };
  }

  updateChartData(series: any) {
    this.chartOptions = {
      series: [
        {
          name: 'N° reservas',
          type: 'line',
          data: series
        }
      ]
    };
    this.updateFlag = true;
  }

  isAll() {
    if (this.is_all) {
      this.SearchTourComponent.isDisabled();
    } else {
      this.SearchTourComponent.notDisabled();
    }
    this.params.is_all = this.is_all;
  }

  generateReport() {
    if (this.validate()) {
      this.generate = true;
      if (this.view_yearly.id == this.ViewSummarySelected) {
        let val_params = 'tour_id=' + this.params.tour_id+'&is_all='+this.params.is_all+'&year='+this.year;
        this.scheduleService.viewSummary(val_params).subscribe({
          next: (data: any) => {
            this.response_summarytour = data.response_summarytour;
            if(this.is_all){              
              for (let i in this.response_summarytour) {
                for (let j in this.obj_months) {         
                  let check_validation = false;       
                  let total = 0;  
                  for(let a in this.response_summarytour[i].summary_quantity_yearly){                    
                    if(this.obj_months[j].number_month == this.response_summarytour[i].summary_quantity_yearly[a].number_month){
                      check_validation = true;
                      break;
                    }
                    total = total + Number(this.response_summarytour[i].summary_quantity_yearly[a].sum_by_month);
                  }

                  if(!check_validation){
                    let obj = {
                      number_month: this.obj_months[j].number_month, 
                      name: this.obj_months[j].name, 
                      sum_by_month: 0
                    }
                    this.response_summarytour[i].summary_quantity_yearly.push(obj)
                  }

                  this.response_summarytour[i].totales_pax = total;
                }
            
                this.response_summarytour[i].summary_quantity_yearly.sort((a: any, b: any) => {
                  return parseInt(a.number_month) - parseInt(b.number_month);
                });
              }
            }else{              
              for (let j in this.obj_months) {         
                let check_validation = false;       
                let total = 0;  
                for(let a in this.response_summarytour.summary_quantity_yearly){                    
                  if(this.obj_months[j].number_month == this.response_summarytour.summary_quantity_yearly[a].number_month){
                    check_validation = true;
                    break;
                  }
                  total = total + Number(this.response_summarytour.summary_quantity_yearly[a].sum_by_month);
                }

                if(!check_validation){
                  let obj = {
                    number_month: this.obj_months[j].number_month, 
                    name: this.obj_months[j].name, 
                    sum_by_month: 0
                  }
                  this.response_summarytour.summary_quantity_yearly.push(obj)
                }
                this.response_summarytour.totales_pax = total;
              }
          
              this.response_summarytour.summary_quantity_yearly.sort((a: any, b: any) => {
                return parseInt(a.number_month) - parseInt(b.number_month);
              });
            }
          }
        });

        // this.initializeChart();
      }
    }
  }

  validate() {
    if (!this.is_all) {
      if (this.tourSelected == null) {
        this.alertifyMsg.warning('Debe seleccionar el tours');
        this.SearchTourComponent.focused();
        return false;
      }
    }
    return true;
  }

  printer(){
    (<any>$('#body_print')).printThis({
      importCSS: true,
  });
  }

  reset() {
    this.response_summarytour = [];
    this.generate = false;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reportes/lista']);
  }
}
